export const getCookie = (cookieName) => {
  const name = `${cookieName}=`
  const decodeCookies = decodeURIComponent(document.cookie)
  const cookiesArray = decodeCookies.split(';')
  for (let i = 0; i < cookiesArray.length; i += 1) {
    let cookie = cookiesArray[i]
    // Quita los espacios en blanco
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return undefined
}

export const parseToInt = (value) => {
  const price = typeof value === 'string' ? value.replace(/,/g, '') : value

  return parseFloat(price)
}

export const formatDecimalNumber = number =>
  Number.parseFloat(parseToInt(number)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/**
 * Compare a given array of substrings with the given string.
 *
 * @param {string} needle
 * @param {array|string} haystack
 *
 * @return {array}
 */
export const stringContainsAnyOf = (needle, haystack) =>
  [].concat(haystack).find(substring => needle.includes(substring))

export const userHasRole = (user, roles) => user.role && !!stringContainsAnyOf(user.role, roles)



// WEBPACK FOOTER //
// ./src/utils/Utils.js